import { ChangeEvent, useEffect } from "react";
import { getEmployeeList } from "src/apis/employeeApi";
import { CodeForm } from "src/components/common/form/CodeForm";
import { DropDownForm } from "src/components/common/form/DropdownForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { EQM2080_R01HeaderDto } from "./Dto_EQM2080_R01";
import { useEQM2080_R01Store } from "./Store_EQM2080_R01";

interface Props {
	defaultEQM2080_R01HeaderRow: EQM2080_R01HeaderDto;
}

export const Info_EQM2080_R01 = ({ defaultEQM2080_R01HeaderRow }: Props) => {
	const {
		editEQM2080_R01,
		setEditEQM2080_R01,
		selectedEQM2080_R01,
	} = useEQM2080_R01Store();
	const { cycleList } = useCommonCodeStore();
	const { setCodeSearchModalProps } = useUiuxStore();

	const judgeEmpnoFocusId = "judgeEmpnoInput_EQM2080_R01";
	const editData = editEQM2080_R01 ?? defaultEQM2080_R01HeaderRow;

	useEffect(() => {
		if (selectedEQM2080_R01) {
			setEditEQM2080_R01({ ...defaultEQM2080_R01HeaderRow, ...selectedEQM2080_R01 });
		} else {
			setEditEQM2080_R01({ ...defaultEQM2080_R01HeaderRow });
		}
	}, [selectedEQM2080_R01, defaultEQM2080_R01HeaderRow, setEditEQM2080_R01]);

	const handleChange = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;
		setEditEQM2080_R01({
			...editData,
			[name]: value,
		});
	};

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: "judgeEmpno",
			category: "담당자",
			focusId: judgeEmpnoFocusId,
			responseMapping: {
				empNo: "judgeEmpno",
				empNm: "judgeEmpNm",
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList("all");
				return employeeResponse.data.data.find((value) => value.empNo === code);
			},
			extraFilter: () => ({
				judgeEmpno: editData.judgeEmpno || "",
				judgeEmpNm: editData.judgeEmpNm || "",
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData,
		setEditData: setEditEQM2080_R01,
		defaultData: defaultEQM2080_R01HeaderRow,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: "EQM2080_R01",
	});

	const inputWrapperStyle = {
		wrapperStyle: "w-[250px] min-w-[250px] mr-[10px] mb-[5px]",
		titleStyle: "w-[100px] min-w-[100px]",
		inputStyle: "w-[150px] min-w-[150px]",
	};

	const codeWrapperStyle = {
		wrapperStyle: "w-[500px] min-w-[500px] mr-[10px] mb-[5px]",
		titleStyle: "w-[100px] min-w-[100px]",
		codeInputStyle: "w-[150px] min-w-[150px]",
		custNmInputStyle: "w-[255px] min-w-[255px]",
	};

	return (
		<div className="flex items-center flex-wrap px-[12px] pt-[8px] pb-[4px]">
			<DropDownForm<SysCodeDto>
				title="점검주기"
				value={editData.inspectCycle}
				data={cycleList}
				editable={false}
				name="inspectCycle"
				initLabelLess={true}
				onChange={handleChange}
				wrapperOption={inputWrapperStyle}
			/>
			<CodeForm
				label="담당자"
				value={editData.judgeEmpno || ""}
				custNmValue={editData.judgeEmpNm || ""}
				editable={true}
				handleFoucsId={judgeEmpnoFocusId}
				name="judgeEmpno"
				wrapperOption={codeWrapperStyle}
				handleChange={getFieldHandlers("judgeEmpno").onChange}
				onDoubleClick={getFieldHandlers("judgeEmpno").onDoubleClick}
				onKeyDown={getFieldHandlers("judgeEmpno").onEnterKeyDown}
			/>
		</div>
	);
};
